const HomeActionTypes = {
  HOME_GET_REQUEST: 'HOME_GET_REQUEST',
  HOME_GET_SUCCESS: 'HOME_GET_SUCCESS',
  HOME_GET_FAILURE: 'HOME_GET_FAILURE',
  HOME_SET: 'HOME_SET',
  HOME_LOADING: 'HOME_LOADING',
  HOME_RESET_STATE: 'HOME_RESET_STATE',
  SAW_HOME: 'SAW_HOME',
  SET_AI_WRAPPER_REF: 'SET_AI_WRAPPER_REF',
  MENU_IS_OPEN: 'MENU_IS_OPEN',
};

export { HomeActionTypes };
